
class DaySelector {

    constructor(rootNode,
                onDaySelectionChangedFn) {

        this.onDaySelectionChangedFn = onDaySelectionChangedFn;
        this.dayInputs = rootNode.find('.weekcheck .form-check-input');
        this.dayInputs.change(this.onDaysChanged.bind(this))
    }

    updateDaysSelected(selected) {
        this.dayInputs.each(function(i, input){
            input = $(input);
            let val = parseInt(input.val());
            input.setChecked(selected.indexOf(val) !== -1);
        });
    }

    onDaysChanged() {
        let selected = [];
        this.dayInputs.each(function(i, input) {
            input = $(input);
            if(input.isChecked()) {
                let val = parseInt(input.val());
                selected.push(val);
            }
        })
        this.onDaySelectionChangedFn(selected);
    }
}

class DayAndHoursSelector extends DaySelector{

    constructor(rootNode,
                onHoursSelectionChangedFn,
                onDaySelectionChangedFn) {
        super(rootNode, onDaySelectionChangedFn);

        this.onHoursSelectionChangedFn = onHoursSelectionChangedFn;
        this.hoursInput = rootNode.find('.form-range');
        this.hoursInput.change(this.onHoursChanged.bind(this));
    }

    updateSelected(hoursSelected, selected) {
        this.updateDaysSelected(selected);
        this.hoursInput.val(hoursSelected);
        hourRangeUpdated(this.hoursInput);
    }

    onHoursChanged() {
        hourRangeUpdated(this.hoursInput);
        this.onHoursSelectionChangedFn(this.hoursInput.val());
    }
}

class DayAndMinutesSelector extends DaySelector{

    constructor(rootNode,
                onMinutesSelectionChangedFn,
                onDaySelectionChangedFn) {
        super(rootNode, onDaySelectionChangedFn);

        this.onMinutesSelectionChangedFn = onMinutesSelectionChangedFn;
        this.minutesInput = rootNode.find('.minutesrange');
        this.minutesInput.change(this.onMinutesChanged.bind(this));
    }

    updateSelected(minutes, selected) {
        this.updateDaysSelected(selected);
        this.minutesInput.val(minutes);
        minutesRangeUpdated(this.minutesInput);
    }

    onMinutesChanged() {
        minutesRangeUpdated(this.minutesInput);
        this.onMinutesSelectionChangedFn(this.minutesInput.val());
    }
}


class DayTimeDurationSelector extends DaySelector{

    constructor(rootNode,
                onTimeSelectionChangedFn,
                onMinutesSelectionChangedFn,
                onDaySelectionChangedFn) {
        super(rootNode, onDaySelectionChangedFn);

        this.onTimeSelectionChangedFn = onTimeSelectionChangedFn;
        this.onMinutesSelectionChangedFn = onMinutesSelectionChangedFn;
        this.timeInput = rootNode.find('.timerange');
        this.timeInput.change(this.onTimeChanged.bind(this));
        this.minutesInput = rootNode.find('.minutesrange');
        this.minutesInput.change(this.onMinutesChanged.bind(this));
    }

    updateSelected(timeSelected, minutesSelected, selected) {
        this.updateDaysSelected(selected);
        this.timeInput.val(timeSelected);
        timeRangeUpdated(this.timeInput);
        this.minutesInput.val(minutesSelected);
        minutesRangeUpdated(this.minutesInput);
    }

    onTimeChanged() {
        timeRangeUpdated(this.timeInput);
        this.onTimeSelectionChangedFn(this.timeInput.val());
    }

    onMinutesChanged() {
        minutesRangeUpdated(this.minutesInput);
        this.onMinutesSelectionChangedFn(this.minutesInput.val());
    }
}
